/** Remove PreLoader */
const RemovePreLoader = () => {
  const loader = document.querySelector(".pre-loader");
  const root = document.querySelector(".cohora-root");
  loader?.classList.add("d-none");
  root?.classList.add("d-flex");
};

export default RemovePreLoader;
